import React from "react";
import logo from "../anim.svg";

export default function Loader() {
  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[#F8F6ED] z-[9999]">
      <img
        src={logo}
        alt="Demiray Logo"
        className="w-20 h-20 animate-spin-y-slow"
      />
    </div>
  );
}
